export default "__VITE_ASSET__wZXw$ebx__"